import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-20 px-4 bg-[#0F1F3D] border-y border-white/10" data-id="element-110">
      <div className="max-w-3xl mx-auto text-center" data-id="element-111">
        <div className="inline-flex items-center justify-center w-24 h-24 rounded-full bg-[#C6F432]/10 mb-8" data-id="element-112">
          <ShieldCheck className="text-[#C6F432]" size={48} data-id="element-113" />
        </div>
        <h2 className="text-4xl md:text-5xl font-anton text-white mb-6" data-id="element-114">
          🛡️ GARANTÍA 7 DÍAS
        </h2>
        <p className="text-2xl text-gray-300 font-medium mb-4" data-id="element-115">
          Probalo sin riesgo.
        </p>
        <p className="text-xl text-white mb-4" data-id="element-116">
          Si no te sirve:{' '}
          <span className="text-[#C6F432] font-bold" data-id="element-117">
            👉 Te devolvemos el 100%
          </span>
        </p>
        <p className="text-gray-400" data-id="element-118">Sin preguntas.</p>
      </div>
    </section>;
}